import React from 'react';
import { GridMenuOptionItemContainer, GridMenuOptionImage } from './GridMenu-styled';


interface Props {
  option:string,
  imgName:string,
  assetURI:string,
  isSelected:boolean,
  onClick:(value:any)=>void,
  isMobile:boolean,
  isLowHeight:boolean
}

export class GridMenuItem extends React.Component<Props,{}> {
  constructor(props) {
    super(props)
  }

  public render = () => {
    const { option, imgName, assetURI, isSelected, onClick, isMobile, isLowHeight } = this.props;

    return (
      <GridMenuOptionItemContainer className="threed-configurator-menu-option-item"
        isSelected={isSelected}
        onClick={(e:React.MouseEvent) => {
          onClick(option);
          e.stopPropagation();
        }}
      >
        <GridMenuOptionImage
          src={`${assetURI}${imgName}.png`}
        />
        <div>
          {option}
        </div>
      </GridMenuOptionItemContainer>
    )
  }
  

  
};